import React, { useState } from 'react'

let aComponent = null
let aComponentOnChange = () => console.log('not set')

export default ({ recaptchaSiteKey, verifyRecaptcha }) => {
  aComponentOnChange = response => verifyRecaptcha(response)
  const [componentSet, setComponentSet] = useState(false)
  if (!componentSet) {
    if (!aComponent)
      import('react-google-recaptcha').then(({ default: ReCAPTCHA }) => {
        aComponent = <ReCAPTCHA sitekey={recaptchaSiteKey} onChange={response => aComponentOnChange(response)} />
        setComponentSet(true)
      })
    else setComponentSet(true)
  }

  return aComponent
}
